import { AppBar, createStyles, makeStyles, Toolbar } from '@material-ui/core';
import React from 'react';
const useStyles = makeStyles(() => {
  return createStyles({
    appBar: {
      position: 'relative',
      zIndex: 1
    },
    toolBar: {
      display: 'flex',
      justifyContent: 'space-between',
      color: 'inherit',
      backgroundColor: 'inherit'
    }
  });
});

/**
 * Represents a Toolbar component in an AppBar
 */
export const LayoutAppBar = props => {
  const classes = useStyles(props);
  return /*#__PURE__*/React.createElement(AppBar, {
    position: "sticky",
    className: classes.appBar
  }, /*#__PURE__*/React.createElement(Toolbar, {
    className: classes.toolBar
  }, props.children));
};
//# sourceMappingURL=layout-app-bar.js.map